type FilterSidebarProps = {
  countries?: string[];
  onCountryChange?: (country: string) => void;
  onNicheChange?: (niche: string) => void;
  onLanguageChange?: (language: string) => void;
  selectedCountry?: string;
  selectedNiche?: string;
  selectedLanguage?: string;
  
  // For trips
  typeFilter?: string;
  onTypeChange?: (type: string) => void;
  onReset?: () => void;
};

const commonNiches = [
  'Travel',
  'Lifestyle',
  'Adventure',
  'Beach',
  'Mountain',
  'Food',
  'Culture',
  'Photography',
  'Luxury',
  'Budget'
];

const commonLanguages = [
  'English',
  'Spanish',
  'French',
  'German',
  'Italian',
  'Portuguese',
  'Russian',
  'Chinese',
  'Japanese',
  'Arabic'
];

export default function FilterSidebar({
  countries = [],
  onCountryChange,
  onNicheChange,
  onLanguageChange,
  selectedCountry = '',
  selectedNiche = '',
  selectedLanguage = '',
  typeFilter = '',
  onTypeChange,
  onReset
}: FilterSidebarProps) {
  // If this is for trips (has typeFilter prop)
  const isTripsFilter = onTypeChange !== undefined;

  return (
    <aside className="lg:w-64 shrink-0">
      <div className="border border-gray-200 bg-white p-6 sticky top-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Filters</h3>
          {onReset && (
            <button
              onClick={onReset}
              className="text-xs text-waybook-blue hover:underline"
            >
              Reset
            </button>
          )}
        </div>

        {isTripsFilter ? (
          // Trip Country Filter
          <div className="mb-8">
            <label className="text-sm font-medium text-gray-700 block mb-3">Country</label>
            <select
              value={typeFilter}
              onChange={(e) => onTypeChange!(e.target.value)}
              className="w-full border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-black"
            >
              <option value="">All Countries</option>
              {countries.map((country) => (
                <option key={country} value={country}>
                  {country}
                </option>
              ))}
            </select>
          </div>
        ) : (
          // Creator Filters
          <>
            {/* Country Filter */}
            <div className="mb-8">
              <label className="text-sm font-medium text-gray-700 block mb-3">Country</label>
              <select
                value={selectedCountry}
                onChange={(e) => onCountryChange!(e.target.value)}
                className="w-full border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-black"
              >
                <option value="">All Countries</option>
                {countries.map((country) => (
                  <option key={country} value={country}>
                    {country}
                  </option>
                ))}
              </select>
            </div>

            {/* Niche Filter */}
            <div className="mb-8">
              <label className="text-sm font-medium text-gray-700 block mb-3">Niche</label>
              <select
                value={selectedNiche}
                onChange={(e) => onNicheChange!(e.target.value)}
                className="w-full border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-black"
              >
                <option value="">All Niches</option>
                {commonNiches.map((niche) => (
                  <option key={niche} value={niche}>
                    {niche}
                  </option>
                ))}
              </select>
            </div>

            {/* Language Filter */}
            <div className="mb-8">
              <label className="text-sm font-medium text-gray-700 block mb-3">Language</label>
              <select
                value={selectedLanguage}
                onChange={(e) => onLanguageChange!(e.target.value)}
                className="w-full border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-black"
              >
                <option value="">All Languages</option>
                {commonLanguages.map((language) => (
                  <option key={language} value={language}>
                    {language}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}
      </div>
    </aside>
  );
}
